import styles from './LoginForm.module.scss';

export const loginFormStyles = styles;

export function LoginForm({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

